import React from 'react'
import styled from 'styled-components'
import ScrollAnimation from 'react-animate-on-scroll'

import { white } from 'styles/colors'
import { navHeight, navHeightMobile, cover } from 'styles/global'
import * as spacing from 'styles/spacing'
import { media, mediaDown } from 'styles/media'
import { H1, H4, fontWeights, lineHeights } from 'styles/typography'

import Wrapper from 'components/Wrapper'
import Header from 'components/Header'
import Button from 'components/button/Button'

const Container = styled.div`
  position: relative;
  text-align: center;
  padding-top: ${navHeightMobile};
  color: ${white};
  overflow: hidden;
  background-image: linear-gradient(124.76deg, #e01c41 -1.14%, #7c0007 118.32%);

  ${media.medium`
    text-align: left;
    padding-top: ${navHeight};
    margin-bottom: -2rem;
  `};

  ${media.large`
    margin-bottom: -3rem;
  `};
`

const Outer = styled.div`
  padding-top: 2.5rem;
  padding-bottom: 3rem;

  ${media.small`
    padding-top: 3.5rem;
    padding-bottom: 4rem;
  `};

  ${media.medium`
    padding-top: 4.5rem;
    padding-bottom: 3rem;
  `};

  ${media.large`
    padding-top: 5.25rem;
  `};

  ${media.xLarge`
    padding-top: 6rem;
    padding-bottom: 2rem;
  `};
`

const Inner = styled.div`
  position: static;

  ${media.medium`
    display: flex;
    justify-content: space-between;
  `};
`

const Content = styled.div`
  position: static;
  margin-bottom: ${spacing.large};

  ${mediaDown.medium`
    max-width: 460px;
    margin-left: auto;
    margin-right: auto;
  `};

  ${media.small`
    margin-bottom: ${spacing.xLarge};
  `};

  ${media.medium`
    margin-bottom: 0;
    max-width: 540px;
    padding-right: 5%;
    padding-top: 40px;
  `};

  ${media.large`
    padding-top: 56px;
    padding-right: 7.5%;
    max-width: none;
  `};
`

const Heading = styled(H1)`
  color: ${white};
  font-family: 'Trim Poster';
  margin-bottom: 0.25em;
  font-size: 32px;
  text-transform: uppercase;

  ${media.small`
    font-size: 40px;
  `};

  ${media.medium`
    font-size: 44px;
    white-space: nowrap;
  `};

  ${media.large`
    font-size: 54px;
  `};

  ${media.xLarge`
    font-size: 60px;
  `};
`

const Subheading = styled(H4)`
  color: ${white};
  font-weight: ${fontWeights.medium};
  line-height: ${lineHeights.base};
  margin-bottom: ${spacing.medium};

  ${media.medium`
    margin-bottom: ${spacing.large};
  `};
`

const FigureWrap = styled.div`
  position: relative;
  z-index: 10; /* Position above slant */
  flex-shrink: 0;

  ${mediaDown.medium`
    max-width: 460px;
    margin-left: auto;
    margin-right: auto;
  `};

  ${media.medium`
    width: 500px;
    margin-right: -24px;
    margin-bottom: 0;
  `};

  ${media.large`
    width: 580px;
    transform: translateY(-24px);
    margin-right: -48px;
  `};

  ${media.xLarge`
    width: 660px;
    transform: translateY(-40px);
    margin-right: -32px;
  `};

  &:after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
`

const Figure = styled.img`
  object-fit: cover;
  ${cover('absolute')};
`

const Slant = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: -1px;
  pointer-events: none;
  max-height: 440px;
`

const BenefitsHeader = () => {
  return (
    <Container>
      <Header transparent />
      <Outer>
        <Wrapper>
          <Inner>
            <Content>
              <Heading as={ScrollAnimation} animateIn="fadeInUp" offset={0} delay={200} animateOnce>
                Subscribe & Save
              </Heading>
              <Subheading as={ScrollAnimation} animateIn="fadeInUp" offset={0} delay={400} animateOnce>
                Save up to 30% including free shipping on every order shipped to you every month.
              </Subheading>
              <Subheading as={ScrollAnimation} animateIn="fadeInUp" offset={0} delay={600} animateOnce>
                Vuse+ members enjoy extra perks
              </Subheading>

              <ScrollAnimation animateIn="fadeInUp" offset={0} delay={800} animateOnce>
                <Button to="/subscribe/#steps" theme="custom" customColor={white} variant="outline" size="large">
                  Learn more
                </Button>
              </ScrollAnimation>
            </Content>
            <FigureWrap as={ScrollAnimation} animateIn="fadeIn" offset={0} delay={800} animateOnce>
              <Figure src={`${process.env.BASE_PATH}/images/subscribe/flavours/strawberry.png`} />
            </FigureWrap>
          </Inner>
        </Wrapper>
      </Outer>
      <Slant src={`${process.env.BASE_PATH}/images/subscribe/slant-strawberry.png`} />
    </Container>
  )
}

export default BenefitsHeader
